import React, { useEffect, useRef } from "react";
import { useQuery } from "seed/gql";
import $ from "jquery"
import View from "components/util/schema_form/SchemaForm.view";

function SchemaForm({
  parentRef,
  schema = [],
  parentId,
  initialValues = {},
  submitText = "Guardar",
  submitComponent,
  isPreview = false,
  isReadOnly = false,
  isCommentEnabled = false,
  showSideSteps = true,
  appId,
  actionId,
  flowId,
  nodeId,
  executionId,
  onChange = () => { },
  onSubmit
}) {

  const isDeveloper = sessionStorage.getItem("is_developer") == "true";
  const pageId = sessionStorage.getItem("page_" + flowId)
  const formRef = useRef(null);
  const componentRef = useRef(null);

  const reqNodes = useQuery(`{
    flowNodes {
      createdAt
      inputValues
      outputValues
      uiSettings
      isEnabled
      action { 
        name
        type
        isEditable
        inputStructure
        outputStructure
        uiSettings
        isAnnotation
        app { 
          name
          uiSettings
        }
      }
      isVerified
      flow { name }
    }
  }`, `flow.id=${flowId} ${pageId ? "AND page.id=" + pageId : ""}`, {
    notifyOnNetworkStatusChange: false
  })

  const reqEdges = useQuery(`{
    flowEdges {
      type
      createdAt
      sourceName
      targetName
      source { }
      target { }
      flow { name }
    }
  }`, `flow.id=${flowId} ${pageId ? "AND page.id=" + pageId : ""}`, {
    notifyOnNetworkStatusChange: false
  });

  const reqCollections = useQuery(`{
    collections {
      name
      schema
      uiSettings
    }
  }`, `(flow_id=${flowId} AND is_active=true)`, { 
    orderBy: "name",
    notifyOnNetworkStatusChange: false
  })

  const reqActions = useQuery(`{
    actions {
      name
      outputStructure
    }
  }`, ``, {
    notifyOnNetworkStatusChange: false
  })

  const reqDataTypes = useQuery(`{
    appDatatypes {
      name
      structure
    }
  }`, ``, {
    notifyOnNetworkStatusChange: false
  })

  const dataReqs = {
    nodes: reqNodes,
    edges: reqEdges,
    collections: reqCollections,
    actions: reqActions,
    dataTypes: reqDataTypes
  }

  useEffect(() => {
    setTimeout(() => {
      let inputs = $(".schema-form .MuiInputBase-root, .schema-form input, .schema-form textarea")
      if (inputs.length > 0 && componentRef.current?.contains(inputs[0])) {
        inputs[0].focus();
      }
    }, 750)
  }, []);

  useEffect(() => {
    dataReqs.nodes.refetch();
    dataReqs.edges.refetch();
    dataReqs.collections.refetch();
  }, []);

  useEffect(() => {
    if (formRef.current)
      formRef.current.setValues(initialValues);
    if (parentRef && parentRef.current)
      parentRef.current.setValues(initialValues);
  }, [initialValues]);

  return (
    <View
      formRef={parentRef || formRef}
      componentRef={componentRef}
      schema={schema}
      appId={appId}
      actionId={actionId}
      flowId={flowId}
      nodeId={nodeId}
      parentId={parentId}
      executionId={executionId}
      initialValues={initialValues}
      dataReqs={dataReqs}
      showSideSteps={showSideSteps}
      submitText={submitText}
      submitComponent={submitComponent}
      isPreview={isPreview}
      isDeveloper={isDeveloper}
      isReadOnly={isReadOnly}
      isCommentEnabled={isCommentEnabled}
      onChange={onChange}
      onSubmit={onSubmit}
    />
  );
}

export default SchemaForm;